<!-- Breadcrumb -->
<div class="content-breadcrumb div-breadcrumb">
  <em class="fa fa-file icon-breadcrumb"></em>
  <span class="text-breadcrumb">Relatórios</span>
</div>
<div class="container-fluid">
  <app-card titleCard="Consultar informações">
    <hr>
    <section class="content">
      <div class="container-fluid">
        <div class="row mb-4 mt-4">
          <div class="col-12">
            <form #filterForm="ngForm" autocomplete="off" (ngSubmit)="gerarRelatorio()">
              <div class="row d-flex justify-content-center">
                <div class="form-group col-6 mb-2">
                  <div class="input-group mb-1 ">
                    <input class="form-control" type="text" placeholder="Pesquise pelo nome do titular ou beneficiado"
                      name="beneficiado" [(ngModel)]="filters.beneficiado">
                      <button class="btn btn-default border border-secondary" type="button"
                        (click)="isFiltersCollapsed = !isFiltersCollapsed"><i class="fa fa-sliders"></i></button>
                  </div>
                </div>
                <div class="col-3">
                  <button type="submit" class="btn btn-primary btn-pesquisar me-1"><i class="fa fa-search"></i>&nbsp;Pesquisar</button>
                  <button type="button" class="btn btn-success btn-limpar" (click)="limparFiltros(filterForm);"><i class="fa fa-times-circle"></i>&nbsp;Limpar</button>
                </div>
              </div>

              <div class="row d-flex justify-content-center">
                <div class="collapse col-md-9" [ngbCollapse]="isFiltersCollapsed">
                  <div class="card card-body bg-light">
                    <div class="row" id="divDatas">
                      <div *ngIf="isVisible()" class="col-12 col-sm-6 mb-4">
                        <label class="label-control">Código Guia Médica</label>
                        <input class="form-control mr-sm-2" type="text" placeholder="Informe o código da guia" name="id"
                          [(ngModel)]="filters.id">
                      </div>

                      <div *ngIf="isVisible()" class="col-12 col-sm-6 mb-4">
                        <label class="label-control">Prestadores</label>
                        <ngx-select [items]="listaPrestadores" optionValueField="id" optionTextField="nome"
                          noResultsFound="Nenhum resultado encontrado" placeholder="Informe o prestadores"
                          name="prestador" [(ngModel)]="filters.prestador" #prestador="ngModel">
                        </ngx-select>
                      </div>
                    </div>
                    <div class="row">
                      <div *ngIf="isVisible()" class="col-12 col-sm-6 mb-4">
                        <label class="label-control">CPF Titular</label>
                        <input class="form-control mr-sm-2" type="text" mask="000.000.000-00"
                          placeholder="Informe o CPF" name="cpf" [(ngModel)]="filters.cpf">
                      </div>

                      <div class="col-12 col-sm-6 mb-4">
                        <label class="label-control">Período</label>
                        <input class="form-control datepicker-atendimento"
                          placeholder="Informe o período de atendimento" bsDaterangepicker
                          (bsValueChange)="setPeriodDateFilter($event)" value="{{ getFormatarPeriodoFiltro() }}"
                          [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', adaptivePosition: true, containerClass: 'theme-dark-blue', selectFromOtherMonth: true, showWeekNumbers: false }" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </app-card>

  <div *ngIf="listaRelatorio.length !== 0">
    <app-card titleCard="Template Relatório - HCM">
      <!-- <button class="btn btn-info btn-exportar mb-3 float-right" type="button" (click)="gerarRelatorioAnalitico()">
        <i class="fa fa-file-excel-o"></i> &nbsp; Analítico
      </button>
      <button class="btn btn-success btn-exportar mb-3 mr-3 float-right" type="button"
        (click)="gerarRelatorioSinteticoHCM()">
        <i class="fa fa-download"></i> &nbsp; Sintético
      </button> -->
      <div ngbDropdown class="d-flex justify-content-end btn-exportar float-right mb-3">
        <button ngbDropdownToggle class="dropdown-toggle btn btn-info btn-relatorio" id="dropdown"
          role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fa fa-download"></i> &nbsp; Relatórios
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdown">
          <button  class="btn btn-light" ngbDropdownItem (click)="gerarRelatorioAnalitico()">
            <i class="fa fa-file-excel-o"></i> &nbsp; Analítico
          </button>
          <button *ngIf="isVisible()" class="btn btn-light" ngbDropdownItem (click)="gerarRelatorioSinteticoHCM()">
            <i class="fa fa-download"></i> &nbsp; Sintético
          </button>
          <button *ngIf="isVisible()" class="btn btn-light" ngbDropdownItem (click)="gerarRelatorioADPHCM()">
            <i class="fa fa-download"></i> &nbsp; ADP
          </button>
        </div>
      </div>
      <div class="table-responsive table-relatorio mt-2">
        <table id="tb-relatorio" class="table table-bordered table-hover text-center text-table table-sm">
          <!-- Table head -->
          <thead>
            <tr class="table-active">
              <!-- <th>Atendimento</th> -->
              <!-- <th>Autorização</th> -->
              <th>Cód. Prestador</th>
              <th>Nome Prestador</th>
              <th>Contrato</th>
              <th>Matrícula</th>
              <!-- <th>Cód. Beneficiário</th> -->
              <th>Nome Beneficiário</th>
              <th>Início Atedimento</th>
              <th>Término Atendimento</th>
              <th>Total Serviço</th>
              <th>Total Material</th>
              <th>Total Medicamentos</th>
              <th>Total Taxa</th>
              <th>Total Diária</th>
              <th>Total Geral</th>
              <th>Percentual</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let relatorio of listaRelatorio">
              <!-- <td>{{ relatorio.atendimento }}</td> -->
              <!-- <td>{{ relatorio.autorizacao }}</td> -->
              <td>{{ relatorio.codigoPrestador }}</td>
              <td>{{ relatorio.nomePrestador }}</td>
              <td>{{ relatorio.contrato }}</td>
              <td>{{ relatorio.matricula }}</td>
              <!-- <td>{{ relatorio.codigoBeneficiario }}</td> -->
              <td>{{ relatorio.nomeBeneficiario }}</td>
              <td>{{ relatorio.dataInicioAtedimento | date:'dd/MM/yyyy HH:mm:ss' }}</td>
              <td>{{ relatorio.dataTerminoAtendimento | date:'dd/MM/yyyy HH:mm:ss' }}</td>
              <td>R$ {{ relatorio.totalServico | number:'1.2-2' }}</td>
              <td>R$ {{ relatorio.totalMaterial | number:'1.2-2' }}</td>
              <td>R$ {{ relatorio.totalMedicamentos | number:'1.2-2' }}</td>
              <td>R$ {{ relatorio.totalTaxa | number:'1.2-2' }}</td>
              <td>R$ {{ relatorio.totalDiaria | number:'1.2-2' }}</td>
              <td>R$ {{ relatorio.totalGeral | number:'1.2-2' }}</td>
              <td>{{ relatorio.percentual }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </app-card>
  </div>
</div>
